<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card class="pa-1 mb-1">
        <v-list  class="px-1 py-0">
            <v-list-item-content class="pa-1 ma-0 body-2">
                <v-list-item-title class="title body-2">
                    Изменение текста в разделе "Товары группы"
                </v-list-item-title>
            </v-list-item-content>
        </v-list>
        <v-card-actions class="py-0">
            <v-container fluid class="py-0">
                <v-row>
                    <v-col cols="3" class="pa-2">
                        <v-row>
                            <v-col cols="12" class="pa-0 pa-0">
                                <v-select
                                    :items="albums"
                                    label="Альбомы товаров в группе ВК"
                                    v-model="marketModel.album_id"
                                    item-text="title"
                                    item-value="id"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" class="pa-0 pa-0">
                                <v-select
                                    :items="methods"
                                    label="Действие"
                                    v-model="marketModel.method"
                                    item-text="title"
                                    item-value="id"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" class="pa-0 pa-0">
                                <v-select
                                    :items="modes"
                                    label="Действие"
                                    v-model="marketModel.mode"
                                    item-text="title"
                                    item-value="id"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" class="pa-0 pa-0">
                                <v-textarea
                                    rows="2"
                                    name="input-7-1"
                                    v-model="marketModel.search"
                                    :counter="100"
                                    label="Найти"
                                    class="ma-0 pa-0 my-0 py-0"
                                    required
                                    auto-grow
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" class="pa-0 pa-0">
                                <v-textarea
                                    auto-grow
                                    rows="2"
                                    name="input-7-1"
                                    v-model="marketModel.replace"
                                    :counter="100"
                                    label="Заменить на"
                                    class="ma-0 pa-0 my-0 py-0"
                                    required
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" class="pa-0 pa-0">
                                <v-btn
                                        block
                                        color="success"
                                        @click="sendChanges"
                                ><span class="text-capitalize">Внести изменения</span></v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="9" class="">
                        <v-row>
                        <v-col cols="4" class="" v-for="album in albums" :key="album.id">
                            <v-card

                            >
                                <v-card-actions>
                                    <v-container fluid class="pa-0 ma-0">
                                    <v-row>
                                        <v-col cols="12" class="pt-0">
                                            <v-img
                                                    class="pt-0"
                                                    v-if="album.hasOwnProperty('photo')"
                                                    :src="album.photo.sizes[0].url"
                                                    style="width: 80%"
                                            >
                                            </v-img>
                                        </v-col>
                                        <v-col cols="12" class="py-0">
                                            <span class="caption">Id альбома: {{album.id}}</span>
                                        </v-col>
                                        <v-col cols="12" class="py-0">
                                            <span class="caption" :title="album.title">Название альбома: {{ album.title | truncate(18, '...') }}</span>
                                        </v-col>
                                        <v-col cols="12" class="py-0">
                                            <span class="caption">Название альбома: {{(new Date(album.updated_time*1000)).toLocaleDateString("en-US")}}</span>
                                        </v-col>
                                        <v-col cols="12" class="py-0">
                                            <span class="caption">Количество товара: {{album.count}}</span>
                                        </v-col>
                                        <v-col cols="12" class="py-0">
                                            <v-btn
                                                    color="primary"
                                                    block
                                                    @click="loadAlbumItems(album.id)"
                                            ><span class="text-capitalize caption">Просмотреть</span></v-btn>
                                        </v-col>
                                    </v-row>
                                    </v-container>
                                </v-card-actions>

                            </v-card>
                        </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-actions>
        <tool-market-album-vk-viewer
            :dialog="albumDialog"
            @close="albumDialog = false"
        ></tool-market-album-vk-viewer>
    </v-card>
</template>

<script>

import { mapGetters } from 'vuex'
import ToolMarketAlbumVkViewer from './ToolMarketAlbumVkViewer'
export default {
    name: 'ToolMarket',
    components: {
        ToolMarketAlbumVkViewer
    },
    data() {
        return {
            albums: [],
            albumDialog: false,
            marketModel: {
                album_id: null,
                method: 'market.replace',
                mode: 'replace_down',
                search: null,
                replace: null,
                group_id: null
            },
            methods: [
                { id: 'market.replace', title: 'Заменить текст в описании' },
                { id: 'market.add', title: 'Вставить текст в описание' },
                { id: 'market.price', title: 'Изменить цену' }
            ],
            modes: [
                { id: 'replace_down', title: 'Заменить все ниже текста' },
                { id: 'replace_all', title: 'Заменить все' },
                { id: 'replace', title: 'Заменить найденный текст' }
            ]
        }
    },
    props: [],
    methods: {
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        },
        sendChanges() {
            // let bot = this.getBotById(+this.$route.params['pathMatch'])
            this.$store.dispatch('tools/sendChanges', { data: this.marketModel })
        },
        loadAlbumItems(albumId) {
            this.albumDialog = true
            let bot = this.getBotById(+this.$route.params['pathMatch'])

            let payload = {
                method: 'market.get',
                botId: this.$route.params['pathMatch'],
                params: { owner_id: -bot.group_id, album_id: albumId }
            }
            this.$store.dispatch('tools/loadAlbumItems', payload)
        },
        loadAlbums() {
            let bot = this.getBotById(+this.$route.params['pathMatch'])
            this.marketModel.group_id = bot.group_id
            let payload = { method: 'market.getAlbums', params: { owner_id: -bot.group_id }, botId: bot.id }
            this.$store.dispatch('api/queryVk', payload)
                .then(response => {
                    if (response.type === 'QueryResult') {
                        this.albums = response.response.data.response.items
                    }
                })
        }
    },
    computed: {
        ...mapGetters({
            moduleGroups: 'api/moduleGroups',
            getBotById: 'bots/getBotById',
            loadedBots: 'bots/loadedBots'
        })
    },
    watch: {
        loadedBots() {
            this.loadAlbums()
        }
    },
    created() {
        this.$store.dispatch('bots/loadBots')
        this.loadAlbums()
    },
    filters: {
        truncate(text, length, suffix) { /// *.title | truncate(18, '...')*/
            if (text.length > length) {
                return text.substring(0, length) + suffix
            } else {
                return text
            }
        }
    }
}
</script>

<style scoped>

</style>
